import { useEffect } from "react";
import { CardCore } from "src/Pages/components/CardCore/CardCore";
import { TitleWithValueCore } from "src/Pages/components/TitleWithValueCore/TitleWithValueCore";
import { UseGetContractMetrics } from "../hooks/UseGetContractMetrics";
import { FormatMoney } from "src/shared/Utils/FormatMoney";
import { FormatDateBR } from "src/shared/Utils/FormatDateBR";

export const CardMetricsContracts = ({ id }: { id: string }) => {
  const { dataMetrics, handleGet } = UseGetContractMetrics();

  useEffect(() => {
    handleGet(id);
  }, [id]);

  return (
    <CardCore
      sxStyle={{
        margin: 0,
        "& > *": {
          display: "flex",
          flexDirection: "column",
          mb: 2.5,
          pb: 2.5,
          borderBottom: "1px solid #e0e0e0",
          "&:last-child": {
            borderBottom: "none",
            mb: 0,
            pb: 0,
          },
        },
      }}
    >
      <TitleWithValueCore
        sxStyleTitle={{ fontWeight: "500", fontSize: "16px" }}
        title="Próxima parcela"
        value={`Vence: ${FormatDateBR(dataMetrics.nextInstallment)}`}
      />
      <TitleWithValueCore
        sxStyleTitle={{ fontWeight: "500", fontSize: "16px" }}
        title="Lucro"
        value={`Total: ${FormatMoney(dataMetrics.profit)}`}
      />
      <TitleWithValueCore
        sxStyleTitle={{ fontWeight: "500", fontSize: "16px" }}
        title="Parcelas recebidas"
        value={`Total: ${dataMetrics.receivedInstallments}`}
      />
      <TitleWithValueCore
        sxStyleTitle={{ fontWeight: "500", fontSize: "16px" }}
        title="Arquivos"
        value={`Total: ${dataMetrics.files}`}
      />
    </CardCore>
  );
};
